import React from "react";
import {useParams} from "react-router-dom";
import solutions from "./ServicesData";
import "./Detail.css";


const ServiceDetail = () => {


const {slug}=useParams();


const solution = solutions.find(
(item)=>item.slug===slug
);



if(!solution){

return <h2>Solution Not Found</h2>

}



return (

<section className="backdiv">
<div>
<div className="servicep-icon">{solution.icon}</div>

<h2 className="main-title">
{solution.title}
</h2>

<p className="main-text text-center">
{solution.pageDescription}
</p>
</div>


<div className="benefits-section">
<h2>Key Benefits</h2>

<div className="benefit-grid">
{
solution.benefits.map((item,index)=>(

<div key={index} className="benefit-card">
<span>✓</span>
<p>{item}</p>
</div>

))
}

</div>
</div>


<div className="approach-box">
<h2 className="approach-head">Our Approach</h2>
<p className="main-text-white">{solution.approach}</p>
</div>
</section>

)

}


export default ServiceDetail;